/**
 * Índice principal do sistema Lifecycle
 * Exporta todos os serviços e gerenciadores de ciclo de vida
 */

// Eventos do ciclo de vida
export { AppLifecycleEvent } from './events/lifecycle-events';

// Serviços principais
export { SessionManager } from './services/session-manager';
export { ConnectivityService } from './services/connectivity-service';
export { ErrorReporter } from './services/error-reporter';
export { TaskScheduler } from './services/task-scheduler';

// Utilitários
export { ThrottleAndDebounce } from './utils/throttle-debounce';

// Integrador principal
import { LifecyclePlatformIntegrator } from './platform-integrator';

/**
 * Inicializa todo o sistema de lifecycle
 */
export class LifecycleManager {
  private static isInitialized = false;

  /**
   * Inicializa o sistema de lifecycle com integração de plataforma
   */
  static async initialize(): Promise<void> {
    if (this.isInitialized) return;

    try {
      console.log('🔄 Inicializando sistema Lifecycle...');

      // Inicializa o integrador que cuida de tudo
      await LifecyclePlatformIntegrator.initialize();

      this.isInitialized = true;
      console.log('✅ Sistema Lifecycle inicializado com sucesso');

    } catch (error) {
      console.error('❌ Erro ao inicializar Lifecycle:', error);
      throw error;
    }
  }

  /**
   * Verifica se o sistema foi inicializado
   */
  static get initialized(): boolean {
    return this.isInitialized;
  }

  /**
   * Obtém status completo do sistema
   */
  static getSystemStatus() {
    return LifecyclePlatformIntegrator.getIntegrationStatus();
  }

  /**
   * Força sincronização de todos os sistemas
   */
  static async syncAllSystems(): Promise<void> {
    await LifecyclePlatformIntegrator.syncSystems();
  }

  /**
   * Cleanup completo do sistema
   */
  static cleanup(): void {
    LifecyclePlatformIntegrator.cleanup();
    this.isInitialized = false;
    console.log('🧹 Sistema Lifecycle limpo');
  }
}

// Exportação default
export default LifecycleManager;
